<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-toolbar class="app--toolbar"   color="primary"
                   fixed
                   dark
                   app v-if="!$route.meta.fr">
          <v-toolbar-title class="ml-0 pl-3">
            <span class="hidden-sm-and-down">  جمعية تواصل الأجيال</span>
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat to="/accueil"> <h4>الصفحة الرئيسية</h4></v-btn>
            <v-btn flat to="/dashboard"> <h4>إحصائيات</h4></v-btn>

              <v-menu offset-y style="padding-right: 20px;padding-left: 20px">
                <v-btn
                        icon
                        slot="activator"
                        color="primary"
                        dark
                >
                  <v-icon>g_translate</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                          v-for="(item, index) in items"
                          :key="index"
                          @click="changeroute(item.title)"
                  >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>

          </v-toolbar-items>
          <div class="hidden-md-and-up">
            <v-btn icon to="/accueil">
            <v-icon> home</v-icon>
          </v-btn>

            <v-btn icon to="/dashboard/fr">
              <v-icon> donut_large</v-icon>
            </v-btn>
            <v-menu offset-y>
              <v-btn
                      slot="activator"

                      icon
              >
                <v-icon>g_translate</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                        v-for="(item, index) in items"
                        :key="index"
                        @click="changeroute(item.title)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
        <v-toolbar class="app--toolbar"   color="primary"
                   fixed
                   dark
                   app v-else>
          <v-toolbar-title class="ml-0 pl-3">
            <span class="hidden-sm-and-down">Association de la Continuité des Générations </span>
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat to="/accueil/fr"> <h4>Accueil</h4></v-btn>
            <v-btn flat to="/dashboard/fr"> <h4>Statistique</h4></v-btn>

            <v-menu offset-y>
              <v-btn
                      slot="activator"
                      color="primary"
                      dark
              >
                <v-icon>g_translate</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                        v-for="(item, index) in items"
                        :key="index"
                        @click="changeroute(item.title)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>

          </v-toolbar-items>
          <div class="hidden-md-and-up">
            <v-btn icon to="/accueil/fr">
            <v-icon> home</v-icon>
          </v-btn>

            <v-btn icon to="/dashboard/fr">
              <v-icon> donut_large</v-icon>
            </v-btn>
            <v-menu offset-y>
              <v-btn
                      icon
                      slot="activator"
              >
                <v-icon>g_translate</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                        v-for="(item, index) in items"
                        :key="index"
                        @click="changeroute(item.title)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>

        </v-toolbar>

        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>   
           <!-- App Footer -->
          <v-footer height="auto" >
            <v-card class="indigo lighten-1 white--text text-xs-center" style="width: 100%">
              <v-card-text>
                <v-btn icon class="mx-3 white--text" href="https://web.facebook.com/acg.generations/"  target="_blank">
                  <v-icon size="30px">fa-facebook</v-icon>
                </v-btn>
                <v-btn icon class="mx-3 white--text" href="http://www.acg-generations.org/"  target="_blank">
                  <v-icon size="30px">fa-globe</v-icon>
                </v-btn>
                <v-btn icon class="mx-3 white--text" >
                  <v-icon size="30px">fa-google-plus</v-icon>
                </v-btn>
              </v-card-text>
              <v-card-text class="white--text "style="text-align: center" v-if="!$route.meta.fr">
              <h5>
                جمعية تواصل الأجيال هي جمعية تهدف إلى تقوية قدرات الشباب وتسهيل إندماجهم المهني. كما تهدف إلى تحسن التواصل بين الأجيال هذا إلى جانب النهوض بظروف المواطنين وخاصة النساء الأكثر عرضة للظلم. وبالإضافة إلى تقوية قدرات الشباب فإن الجمعية تسعى من خلال العديد من الأنشطة إلى حماية البيئة والتمية المستدامة
              </h5>
            </v-card-text>
              <v-card-text class="white--text "style="text-align: center;" v-else >
                <h5>
                  جمعية تواصل الأجيال هي جمعية تهدف إلى تقوية قدرات الشباب وتسهيل إندماجهم المهني. كما تهدف إلى تحسن التواصل بين الأجيال هذا إلى جانب النهوض بظروف المواطنين وخاصة النساء الأكثر عرضة للظلم. وبالإضافة إلى تقوية قدرات الشباب فإن الجمعية تسعى من خلال العديد من الأنشطة إلى حماية البيئة والتمية المستدامة
                </h5>
              </v-card-text>
              <v-card-text class="white--text" style="text-align: left">
                <a href="http://www.octadevtn.com/" target="_blank"><strong style="color: white">OctaDevTn</strong> </a> —  &copy;2018
              </v-card-text>
            </v-card>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->
      </v-app>
    </template>
    <template v-else>

          <router-view></router-view>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from  './event';
export default {

  timers: {
    log: { time: 500, autostart: true ,  repeat: true,
    }
  },
  components: {
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings
  },

  data: () => ({
      items: [
          { title: 'العربية' },
          { title: 'Français' },
      ],

      icons: ['fa-facebook', 'fa-twitter', 'fa-google-plus', 'fa-linkedin', 'fa-instagram'],

      expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      show1: false,
      text: '',
      color: '',
    }
  }),

  computed: {

  },

  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    log () {
      console.clear();
    },
      changeroute(ch){
          if(ch==='العربية'){
              this.$router.push('/dashboard')

          }
          else{
              this.$router.push('/dashboard/fr')

          }

      }

      ,
      changeroute2(ch){
          console.log(ch);
          if(ch==='العربية'){
              this.$router.push('/database/Ar')

          }
          else{
              this.$router.push('/database')
          }

      },
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = (!this.rightDrawer);
    }
  },

};
</script>


<style lang="stylus" scoped>

  .setting-fab {
    top:50%!important;
    right:0;
    border-radius:0
  }
  .page-wrapper{
    min-height:calc(100vh - 64px - 50px - 81px );
  }
body{
    font-family: 'Cairo', sans-serif !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue